<template>
	<div id="app" style="overflow: auto;height: 100vh;">
		<router-view />
		<loading></loading>
	</div>
</template>

<script>
	import loading from '@/components/loading.vue'
	export default {
		components: {
			loading
		},
		name: 'App',
		mounted(){
			
		},
	}
</script>

<style lang="scss">
	html,
	body {
		margin: 0;
		padding: 0;
		font-size: 16px;
		color: #333333;
		user-select: none;
		img{
			user-select: none;
			-webkit-user-drag: none;
		}
	}
	
	
	.el-main{
		background: url('assets/bgbg.png') no-repeat bottom !important;
	}
	// 页面主要背景色
	.bgcolor{
		background: #f7f7f7;
		min-height: 100vh;
		min-width: 1200px;
	}
	.topnavs{
		width: 100%;
		height: 110px;
		background: url('assets/topnav.png') no-repeat 100%;
		background-size: cover;
		display: flex;align-items: center;
		position: relative;
		box-sizing: border-box;
		.toplogo{
			width: 620px;
			height: auto;
		}
	}
	
	// 回到顶部组件 配置和重置
	#app {
		height: 100vh;
		overflow: auto;
	}
	.el-backtop:hover{
		background-color: #fff6f7;
	}
	.el-icon-caret-top:before{
		color: #c0211e;
		font-size: 30px;
	}
	
	// 输入框灰色
	.reg-input, .tkmodel,.updatemm{
		.el-input__inner{
			background: #f6f7fa;
			border:  #f6f7fa;
			height: 46px;
		}
	}
	
	// 页面布局
	.el-row {
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
	}
	
	
	.xiancang {
	  text-overflow: -o-ellipsis-lastline;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  display: -webkit-box;
	  -webkit-line-clamp: 1;
	  line-clamp: 1;
	  -webkit-box-orient: vertical;
	}
	.xiancang2 {
	  text-overflow: -o-ellipsis-lastline;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  display: -webkit-box;
	  -webkit-line-clamp: 2;
	  line-clamp: 2;
	  -webkit-box-orient: vertical;
	}
	.xiancang3 {
	  text-overflow: -o-ellipsis-lastline;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  display: -webkit-box;
	  -webkit-line-clamp: 3;
	  line-clamp: 3;
	  -webkit-box-orient: vertical;
	}
	
	.xiancang10 {
	  text-overflow: -o-ellipsis-lastline;
	  overflow: hidden;
	  text-overflow: ellipsis;
	  display: -webkit-box;
	  -webkit-line-clamp: 12;
	  line-clamp: 12;
	  -webkit-box-orient: vertical;
	}
	
	
	
	
	
	// 作业批阅 ---------------------------------------------------------------------
	.pykuang .el-input__inner{
		width: 100%;
		height: 50px !important;
		background: #f6f7fa;
		border: #f6f7fa;
	}

	// 公共处理
	// 导航栏选项卡底部线去掉
	.el-menu.el-menu--horizontal {
		border-bottom: none !important;
		background: rgba(0, 0, 0, 0);
	}
	.el-menu-item{
		font-size: 16px !important;
		color: #ffffff !important;
		height: 62px !important;
		line-height: 62px !important;
		padding: 0 30px;
		font-size: 18px !important;
	}
	// 个人中心导航栏
	.menus{
		.el-menu-item{
			font-size: 16px !important;
			color: #666666 !important;
			padding: 0;
			margin-right: 60px !important;
		}
	}
	.pubbg{
		width: 100%;
		height: 286px;
		background: url('assets/pubbg.png') no-repeat;
		background-size: cover;
		margin-top: -1px;
	}
	.pubbg{
		display: flex;align-items: center;justify-content: center;
		.el-input{
			width: 710px !important;
		}
		.el-input__inner{
			border: none !important;
			background-color: rgba(255, 255, 255, 0.3) !important;
			border-radius: 26px !important;
			color: #fff !important;
			height: 60px !important;
			line-height: 60px !important;
			width: 710px !important;
			padding: 0 50px !important;
			font-size: 20px !important;
		}
		.el-input__inner::placeholder{
			color: #fff !important;
		}
		.el-input__prefix{
			font-size: 24px;
			color: #fff !important;
			left: 15px !important;
			top: 3px !important;
		}
		.anniusousuo{
			width: 120px;
			height: 60px;
			cursor: pointer;
			line-height: 60px;
			text-align: center;
			background: #960000;
			font-size: 24px;
			color: #fff;
			border-radius: 60px;
			margin-left: -80px;
			z-index: 99;
		}
		
	}
	
	.pubbgsaa{
		display: flex;align-items: center;justify-content: center;
		.el-input{
			width: 200px !important;
		}
		.el-input__inner{
			border: none !important;
			background-color: rgba(255, 255, 255, 0.3) !important;
			border-radius: 16px !important;
			color: #fff !important;
			height: 38px !important;
			line-height: 38px !important;
			width: 200px !important;
			padding: 0 50px !important;
			font-size: 14px !important;
		}
		.el-input__inner::placeholder{
			color: #fff !important;
		}
		.el-input__prefix{
			font-size: 18px;
			color: #fff !important;
			left: 15px !important;
			top: 0px !important;
		}
		.anniusousuo1{
			width: 76px;
			height: 38px;
			cursor: pointer;
			line-height: 38px;
			text-align: center;
			background: #960000;
			font-size: 16px;
			color: #fff;
			border-radius: 38px;
			margin-left: -40px;
			z-index: 99;
		}
	}
	
	.mingshia .el-carousel__mask{
		background: none !important;
	}
	.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
		background: rgba(0, 0, 0, 0) !important;
	}
	.el-menu--horizontal>.el-menu-item{
		border-bottom: 0 !important;
	}
	
	// 导航栏选中状态
	.top-all .is-active {
		color: #ffffff !important;
		font-weight: bold;
		// border-bottom: 6px solid #ffcd34 !important;
		&::after{
			content: ' ';
			width: 40px;
			height: 6px;
			background: #ffcd34;
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translate(-50%,0);
		}
	}
	

	// 框架内容高度 公共页面  一些特殊页面如果用到el-..在加别的
	.public-page {
		background: #f7f7f7;
		min-height: 100vh;
		min-width: 1200px;
		.content-height {
			min-height: calc(100vh - 110px - 60px - 170px);
			width: 1200px;
			margin: 0 auto;
			margin-bottom: 50px;
		}
		.el-footer,.el-header,.el-main {
			padding: 0 !important;
		}
		.el-main {
			background: #f7f7f7;
			min-width: 1200px;
		}
		.el-footer {
			height: 170px !important;
		}
		.el-header {
			height: 60px !important;
		}
	}
	
	// 顶部导航
	.top-all{
		// 顶部导航输入框圆角
		// .el-input__inner {
		// 	border-radius: 36px !important;
		// 	width: 226px !important;
		// 	height: 36px !important;
		// 	background: #f7f7f7 !important;
		// 	border: none;
		// }
		// 顶部导航输入框搜索按钮
		// .el-icon-search:before {
		// 	color: #ba3f33;
		// 	font-size: 15px;
		// 	font-weight: bold;
		// }
	}
	
	
	// 分割线
	.el-divider--horizontal{
		margin: 20px 0 !important;
	}
	
	
	
	
	// 分页开始
	.fenye{
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 14px 0;
		.el-pagination.is-background .el-pager li:not(.disabled):hover{
			color: #c0221e !important;
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active{
			background-color: #c0221e !important;
			color: #FFF !important;
		}
		.el-select .el-input.is-focus .el-input__inner{
			border-color: #c0221e !important;
		}
		.el-input.is-active .el-input__inner, .el-input__inner:focus{
			border-color: #c0221e !important;
		}
		.el-pagination__sizes .el-input .el-input__inner:hover{
			border-color: #c0221e !important;
		}
	}
	.el-select-dropdown__item.selected{
		color: #c0221e !important;
	}
	// 分页结束
	
	
	.bjzc {
		font-size: 14px;
		color: #2d8af1;
		margin: 0px 8px;
		cursor: pointer;
	}
	
	
	.el-table th.el-table__cell{
		background-color :#fafafa;
	}
	
	.el-radio__input.is-checked+.el-radio__label{
		color: #b63427;
	}
	.el-radio__input.is-checked .el-radio__inner{
		border-color: #b63427;
		background: #b63427;
	}
	// 面包屑
	.el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
		color: #b63427;
	}
	
	
	
	// 富文本层级
	.tox:not([dir=rtl]){
		z-index: 9999999 !important;
	}
	
	
	.con-cen{
		.el-input__inner{
			// width: 220px !important;
			height: 32px;
		}
		.el-input.is-active .el-input__inner, .el-input__inner:focus{ 
			border-color: #c1211f;
		}
		.el-input__icon{
			line-height: 0 !important;
		}
	}
	
</style>



// WEBPACK FOOTER //
// src/App.vue